import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import WhyItMattersPage from "./pages/WhyItMattersPage";
import SimulationPage from "./pages/SimulationPage";
import ApproachPage from "./pages/ApproachPage";
import TeamPage from "./pages/TeamPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";
import ImprintPage from "./pages/ImprintPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import "./App.css";
import "./refinements.css";
import "./legal.css";

const titles = {
  "/": "Birdwatcher — Agroadvisor",
  "/why-it-matters": "Why measurement coverage matters — Birdwatcher",
  "/simulation": "Sampling simulation — Birdwatcher",
  "/approach": "Deployment and calibration — Birdwatcher",
  "/team": "Team — Agroadvisor Birdwatcher",
  "/faq": "FAQ — Agroadvisor Birdwatcher",
  "/contact": "Contact — Agroadvisor Birdwatcher",
  "/imprint": "Imprint — Agroadvisor Birdwatcher",
  "/privacy": "Privacy and data protection — Agroadvisor Birdwatcher",
  "/terms": "Terms of use — Agroadvisor Birdwatcher",
};

function AnimatedRoutes() {
  const location = useLocation();

  useEffect(() => {
    document.title = titles[location.pathname] || "Birdwatcher — Agroadvisor";
  }, [location.pathname]);

  return (
    <Layout>
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          className="route-page"
          key={location.pathname}
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.32, ease: [0.22, 1, 0.36, 1] }}
        >
          <Routes location={location}>
            <Route path="/" element={<HomePage />} />
            <Route path="/why-it-matters" element={<WhyItMattersPage />} />
            <Route path="/simulation" element={<SimulationPage />} />
            <Route path="/approach" element={<ApproachPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/imprint" element={<ImprintPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
